import { MIN_ADS_COUNT } from '@/constants/others'

type screenSize = {
  isSmall?: boolean
  isMedium?: boolean
  isLarge?: boolean
}

/**
 *
 * This method returns the minimum number of ads based on the screen size.
 * Currently we have 3 types of sizes - Large screen(desktop), Medium screen(tablet), Small screen(mobile)
 * Each screen has a dedicated minimum ads that we show to maintain the UX/UI experience.
 *
 * @param { object } - An object containing three properties - isSmall, isMedium, isLarge in the form of boolean
 * @returns number of min ads
 *
 *
 * @example
 * getMinimumAdsForScreenSize({isSmall: true, isMedium: false,isLarge: false}) // return 2
 * getMinimumAdsForScreenSize({isSmall: false, isMedium: true ,isLarge: false}) // returns 4
 *
 */
export const getMinimumAdsForScreenSize = ({
  isSmall = false,
  isMedium = false,
  isLarge = true,
}: screenSize) => {
  if (isSmall) {
    return MIN_ADS_COUNT.SMALL_SCREEN
  }
  if (isMedium) {
    return MIN_ADS_COUNT.MEDIUM_SCREEN
  }
  if (isLarge) {
    return MIN_ADS_COUNT.LARGE_SCREEN
  }
  return MIN_ADS_COUNT.LARGE_SCREEN
}
